import { toast } from 'react-toastify';
import { get } from 'lodash';

import Api from 'lib/api';

const api = Api.getInstance();

const ns = 'app/nonprofits';

export const LOAD_START = ns + 'LOAD_START';
export const LOAD_FAILURE = ns + 'LOAD_FAILURE';
export const LOAD_SUCCESS = ns + 'LOAD_SUCCESS';

export const VIEW_START = ns + 'VIEW_START';
export const VIEW_FAILURE = ns + 'VIEW_FAILURE';
export const VIEW_SUCCESS = ns + 'VIEW_SUCCESS';

export const SAVE_START = ns + 'SAVE_START';
export const SAVE_FAILURE = ns + 'SAVE_FAILURE';
export const SAVE_SUCCESS = ns + 'SAVE_SUCCESS';

export const DELETE_START = ns + 'DELETE_START';
export const DELETE_FAILURE = ns + 'DELETE_FAILURE';
export const DELETE_SUCCESS = ns + 'DELETE_SUCCESS';

export const CATS_LOADED = ns + 'CATS_LOADED';
export const USERS_LOADED = ns + 'USERS_LOADED';

export function getNonprofits(page = 1) {
  return async dispatch => {
    dispatch({
      type: LOAD_START
    });

    try {
      const response = await api.get('nonprofits', { params: { page: page } });

      const { data } = response;

      if (data.success) {
        dispatch({
          type: LOAD_SUCCESS,
          payload: data.data
        });
      } else {
        dispatch({
          type: LOAD_FAILURE,
          payload: data
        });
      }
    } catch (error) {
      dispatch({
        type: LOAD_FAILURE,
        payload: error.response
      });
    }
  };
}

export function saveNonprofit(nonprofit, history, reset) {
  return async dispatch => {
    dispatch({
      type: SAVE_START
    });

    try {
      const response = await api.put(`nonprofits/${nonprofit.id}`, nonprofit);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: SAVE_SUCCESS
        });

        toast.success('Nonprofit saved successfully!');

        reset();

        history.push('/nonprofits');
      } else {
        toast.error('Unable to save nonprofit.');

        dispatch({
          type: SAVE_FAILURE,
          payload: data.errors
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SAVE_FAILURE,
        payload: response
      });
    }
  };
}

export function deleteNonprofit(id, callback) {
  return async dispatch => {
    dispatch({
      type: DELETE_START
    });

    try {
      const response = await api.post(
        `users/delete-organization/nonprofit/${id}`
      );

      const { data } = response;

      if (data.success) {
        toast.success('Nonprofit deleted successfully!');
        dispatch({
          type: DELETE_SUCCESS,
          payload: data
        });
        callback();
      } else {
        toast.error('Unable to delete nonprofit!');
        dispatch({
          type: DELETE_FAILURE,
          payload: data
        });
      }
    } catch (error) {
      toast.error(
        get(error, 'response.data.data.message', 'Unable to delete nonprofit!')
      );
      dispatch({
        type: DELETE_FAILURE,
        payload: error.response
      });
    }
  };
}

export function load(id) {
  return async dispatch => {
    dispatch({
      type: VIEW_START
    });

    try {
      const response = await api.get(`nonprofits/${id}`);

      const { data } = response;

      if (data.success) {
        dispatch({
          type: VIEW_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: VIEW_FAILURE,
          payload: data
        });
      }
    } catch (error) {
      dispatch({
        type: VIEW_FAILURE,
        payload: error.response
      });
    }
  };
}

export function saveAsk(ask) {
  return async dispatch => {
    dispatch({
      type: SAVE_START,
      payload: ask.id
    });

    try {
      let saveData = {};

      if (!ask.saved) {
        let notes = window.prompt(
          'Enter some notes you would like to save with the ask (optional)'
        );

        if (notes !== null) {
          notes = notes.trim();
          if (notes) {
            saveData.notes = notes;
          }
        }
      }

      const response = await api.post(`asks/save/${ask.id}`, saveData);
      const { data } = response;

      if (data.success) {
        if (ask.saved) {
          // if the ask was saved, it shouldn't be any more.
          toast.success('Saved ask removed.');
        } else {
          toast.success('Ask saved!');
        }

        dispatch({
          type: SAVE_SUCCESS,
          payload: ask.id
        });
      } else {
        dispatch({
          type: SAVE_FAILURE,
          payload: ask.id
        });
        toast.error('Unable to update saved ask.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SAVE_FAILURE,
        payload: ask.id
      });
    }
  };
}

export function loadCategories() {
  return async dispatch => {
    const response = await api.get('categories');

    const { data } = response;

    if (data.success) {
      dispatch({
        type: CATS_LOADED,
        payload: data.data
      });
    }
  };
}

export function loadUsers() {
  return async dispatch => {
    const response = await api.get('users/list');
    const { data } = response;

    if (data.success) {
      dispatch({
        type: USERS_LOADED,
        payload: data.users
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/app/nonprofits/actions.js